import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { useOnboardingJourney } from '../../Data/Onboarding';
import { useSession } from '../Session';
import Clarity from '@microsoft/clarity';
import { Roles } from '../../Data/Users';

ReactGA.initialize('G-1340C5LCEF');
Clarity.init("qkhqbf7wbv");

window.clarity('consentv2', {
    ad_Storage: "granted",
    analytics_Storage: "granted"
});

const trackActivity = (category, action, additionalData = {}) => {
    // Send to Google Analytics
    ReactGA.event({
        category,
        action,
        ...additionalData
    });

    // Send to Clarity
    Clarity.event(`${category}_${action}`, additionalData);
};

const Analytics = () => {
    const {user, business, plan, hasToken, adminLevel, isRoleSufficient} = useSession();
    const location = useLocation();
    const {journey} = useOnboardingJourney(false, !hasToken || !isRoleSufficient(Roles.MANAGER));

    useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: location.pathname + location.search,
            title: window.document.title,
        });
    }, [location.pathname, location.search]);

    useEffect(() => {
        if (!journey) {
            return;
        }

        const progress = journey?.progress?.percent ?? null;
        if (progress) {
            ReactGA.gtag('set','user_properties', {
                onboarding_progress: progress,
            });
        }

        const activity = journey?.activity?.score ?? null;
        if (activity) {
            ReactGA.gtag('set','user_properties', {
                onboarding_activity: activity,
            });
        }
    }, [journey]);

    useEffect(() => {
        if (!user || !business || !plan) {
            return;
        }

        Clarity.identify(user.id);

        ReactGA.gtag('set','user_properties', {
            plan: plan.name,
            businessId: business.id,
            userId: user.id,
            adminLevel,
        });
    }, [user, business, plan, adminLevel]);

    return null;
}

export default Analytics;

export { trackActivity };
